import { toValue, type MaybeRefOrGetter } from 'vue'
import { useQuery } from '@pinia/colada'
import { useTicketTimelineService as useTicketTimelineServiceBase } from './ticket-timeline.composable'
import { CACHE_TTL, CACHE_KEYS } from '@/services/cache'
import type { TicketTimeline } from './ticket-timeline.types'

/**
 * Ticket timeline service with caching.
 *
 * Architecture: Drawer → ticket-timeline.cached.ts → ticket-timeline.composable.ts → ticket-timeline.api.ts
 */
export function useTicketTimelineService() {
  const service = useTicketTimelineServiceBase()

  /** One ticket's runs, PRs and Claude's comments; reads only while a key is set. */
  const useTicketTimeline = (key: MaybeRefOrGetter<string | null>) => {
    return useQuery({
      key: () => CACHE_KEYS.ticketTimeline.byKey(toValue(key) ?? ''),
      query: (): Promise<TicketTimeline> => service.getTimeline(toValue(key) ?? ''),
      staleTime: CACHE_TTL.TICKET_TIMELINE,
      enabled: () => Boolean(toValue(key))
    })
  }

  return { useTicketTimeline }
}
